<template>
    <div class="details_body">
        <ul class="details_tab">
            <li @click="num = 0" :class="{active: num == 0}">云主机介绍</li>
            <li @click="num = 1" :class="{active: num == 1}">功能介绍</li>
            <li @click="num = 3" :class="{active: num == 3}">云主机参数</li>
            <li @click="num = 2" :class="{active: num == 2}">购买须知</li>
        </ul>
        <div class="details_gn" v-show="num == 0">
            <p>文华利用云机房为量化交易者精心打造的极速、可靠、无阻网络环境，让网络对量化交易的影响趋近于"0"。</p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 1">
            <p>1.极速行情</p>
            <p>2.云端24小时运行程序化模型</p>
            <p><a href="https://wt8.wenhua.com.cn/#/proc/" target="_blank">>>> 点击查看更详细介绍</a></p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 2">
            <p class="tent">1.可向文华申请云主机试用，每位用户只可享受一次。</p>
            <p class="tent">2.使用软件<a href="https://wt8.wenhua.com.cn/#/download" target="_blank">赢智（wh8）</a>、<a href="https://wh9.wenhua.com.cn/Download/index" target="_blank">库安（wh9）</a>。</p>
            <p class="tent">3.付款后4个小时工作时间内，我们会联系您，告知您云主机的登录账号。</p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 3">
            <table>
                <tr>
                    <th rowspan="2">型号</th>
                    <th rowspan="2">CPU</th>
                    <th rowspan="2">内存</th>
                    <th rowspan="2">数据盘</th>
                    <th rowspan="2">公网IP</th>
                    <th colspan="2" style='padding: 3px;'>带宽</th>
                    <th rowspan="2">价格</th>
                </tr>
                <tr>
                    <th style='padding: 3px;'>数据带宽</th>
                    <th style='padding: 3px;'>维护带宽</th>
                </tr>
                <!-- <tr>
                    <td>云主机Ⅱ型</td>
                    <td>四核</td>
                    <td>4G</td>
                    <td>150G</td>
                    <td>1个</td>
                    <td>1000M</td>
                    <td>5M</td>
                    <td>12000元/年/服务器</td>
                </tr> -->
                <tr>
                    <td>云主机Ⅲ型</td>
                    <td>四核</td>
                    <td>8G</td>
                    <td>150G</td>
                    <td>1个</td>
                    <td>1000M</td>
                    <td>5M</td>
                    <td>13800元/年/服务器</td>
                </tr>
                <tr>
                    <td>云主机Ⅳ型</td>
                    <td>八核</td>
                    <td>16G</td>
                    <td>150G</td>
                    <td>1个</td>
                    <td>1000M</td>
                    <td>5M</td>
                    <td>18000元/年/服务器</td>
                </tr>
            </table>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                num: 2
            }
        },
    }
</script>
<style scoped>
@import url('./doc.css');
.details_gn {
    min-height: 150px;
}
</style>